export function getUserProgressData(logs, level1Id, level2Id) {
	if (!logs || logs.length <= 0) {
		return {
			hasDoneLevel1: false,
			hasDoneLevel2: false,
			level1Progress: 0,
			level2Progress: 0,
		}
	}

	// Get level and module progression
	let hasDoneLevel1 = 0
	let hasDoneLevel2 = 0
	let level1Progress = {}
	let level2Progress = {}

	logs.forEach((log) => {
		switch (log.type.slug) {
			case 'module':
				if (log.data.isQuest === true) {
					level2Progress[log.data_key] = true
				} else if (log.data.isQuest === false) {
					level1Progress[log.data_key] = true
				}
				break

			case 'course':
				if (log.data_key == level1Id) {
					hasDoneLevel1 = true
				} else if (log.data_key == level2Id) {
					hasDoneLevel2 = true
				}
				break
		}
	})

	level1Progress = Object.keys(level1Progress).length
	level2Progress = Object.keys(level2Progress).length

	return {
		hasDoneLevel1,
		hasDoneLevel2,
		level1Progress,
		level2Progress,
	}
}

export function getUserState(user) {
	if (user.disabled) {
		return 'disabled'
	} else if (!user.cognito_id && !user.cognito_confirmed) {
		return 'inactive'
	} else if (user.cognito_id) {
		if (user.cognito_confirmed) {
			return 'active'
		} else {
			return 'pending'
		}
	} else {
		return 'exist'
	}
}

export function getUserGroupState(user) {
	// Check if the user group is not disabled and still active (start/end date)
	if (user.groups?.length > 0) {
		if (user.groups[0].group.disabled) {
			return 'disabled'
		} else {
			const now = Date.now()
			const startDate = new Date(user.groups[0].group.start_date)
			const endDate = new Date(user.groups[0].group.end_date)

			if (now < startDate.getTime() || now > endDate.getTime()) {
				return 'inactive'
			}
		}
	}

	return null
}
